module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    staticClass: "edit-profile-form"
  }, [_c('div', {
    staticClass: "form-grouup"
  }, [_c('label', {
    staticClass: "col-lg-3 control-label"
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-lg-9"
  }, [_c('croppa', {
    ref: "croppa",
    attrs: {
      "width": 256,
      "height": 256,
      "canvas-color": 'transparent',
      "placeholder": 'Choose an avatar',
      "show-loading": true,
      "initial-image": _vm.avatar,
      "accept": 'image/*'
    },
    model: {
      value: (_vm.myCroppa),
      callback: function($$v) {
        _vm.myCroppa = $$v
      },
      expression: "myCroppa"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-grouup"
  }, [_c('label', {
    staticClass: "col-lg-3 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-lg-9"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email",
      "type": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-grouup"
  }, [_c('label', {
    staticClass: "col-lg-3 control-label"
  }, [_vm._v("First name")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-lg-9"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "First name"
    },
    model: {
      value: (_vm.firstname),
      callback: function($$v) {
        _vm.firstname = $$v
      },
      expression: "firstname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-grouup"
  }, [_c('label', {
    staticClass: "col-lg-3 control-label"
  }, [_vm._v("Last name")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-lg-9"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Last name"
    },
    model: {
      value: (_vm.lastname),
      callback: function($$v) {
        _vm.lastname = $$v
      },
      expression: "lastname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "update-btn",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        return _vm.handleClickUpdate()
      }
    }
  }, [_vm._v("Update")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a9990e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/user/EditProfileForm.vue
// module id = 3294
// module chunks = 3